import type { AllHTMLAttributes, ReactNode } from "react";

import styles from "./tabs-icon.module.css";

export type TabsIconProps = {
  children: ReactNode;
} & AllHTMLAttributes<HTMLDivElement>;

export function TabsIcon({ children, ...props }: TabsIconProps) {
  return (
    <div {...props} className={styles.Container}>
      {children}
    </div>
  );
}
